<template>
  <div id="mybill">
    <Breadcrumb></Breadcrumb>

    <div class="common-limit line-height-40">
      <div class="form-body">
        <el-form ref="form" :model="form" label-width="80px">
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="grid-content bg-purple">
                <el-form-item label="操作账号：" class="item">
                  <div
                    style="
                      max-height: 200px;
                      overflow-y: auto;
                      float: left;
                      width: calc(100% - 59px);
                    "
                  >
                    <el-input
                      v-if="isExpandUser"
                      style="width: 139px; margin: 0 29px 0 0"
                      v-model="nickName"
                      size="small"
                      placeholder="操作账号"
                    ></el-input>
                    <el-checkbox
                      @change="handleChangeUser"
                      v-model="isCheckUser"
                      >全选</el-checkbox
                    >
                    <el-checkbox-group
                      filterable
                      v-model="form.operNo"
                      placeholder="请选择姓名"
                      class="input"
                      size="small"
                      clearable
                      style="display: inline; margin: 0 0 0 27px"
                      @change="handleChangeOper"
                    >
                      <el-checkbox
                        v-for="(item, index) in userList"
                        :key="index"
                        :label="item.userName"
                        v-show="
                          (isExpandUser || index < 10) &&
                          item.nickName &&
                          item.nickName.indexOf(nickName) > -1
                        "
                      >
                        {{ item.nickName }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                  <div
                    v-if="userList.length > 10"
                    @click="isExpandUser = !isExpandUser"
                    style="
                      margin: 0 0 0 16px;
                      cursor: pointer;
                      color: #409eff;
                      float: left;
                    "
                  >
                    {{ isExpandUser ? "－收起" : "＋展开" }}
                  </div>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="grid-content bg-purple">
                <el-form-item label="店铺名称：" class="item">
                  <div
                    style="
                      max-height: 200px;
                      overflow-y: auto;
                      float: left;
                      width: calc(100% - 59px);
                    "
                  >
                    <el-input
                      v-if="isExpand"
                      style="width: 139px; margin: 0 29px 0 0"
                      v-model="shopName"
                      size="small"
                      placeholder="店铺名称"
                    ></el-input>
                    <el-checkbox
                      @change="handleChangeShop"
                      v-model="isCheckShop"
                      >全选</el-checkbox
                    >
                    <el-checkbox-group
                      filterable
                      v-model="form.shopIds"
                      placeholder="请选择店铺名称"
                      class="input"
                      size="small"
                      clearable
                      style="display: inline; margin: 0 0 0 27px"
                    >
                      <el-checkbox
                        v-for="(item, index) in shopList"
                        :key="index"
                        :label="item.shopId"
                        v-show="
                          (isExpand || index < 10) &&
                          item.shopName.indexOf(shopName) > -1
                        "
                      >
                        {{ item.shopName
                        }}<span v-if="item.amazonSite"
                          >({{ dictMap["amazon_site"][item.amazonSite] }})</span
                        >
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                  <div
                    v-if="shopList.length > 10"
                    @click="isExpand = !isExpand"
                    style="
                      margin: 0 0 0 16px;
                      cursor: pointer;
                      color: #409eff;
                      float: left;
                    "
                  >
                    {{ isExpand ? "－收起" : "＋展开" }}
                  </div>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <div class="grid-content bg-purple">
                <el-form-item label="订单状态：" class="item">
                  <el-checkbox
                    @change="handleChangeStatus"
                    v-model="isCheckStatus"
                    >全选</el-checkbox
                  >
                  <el-checkbox-group
                    clearable
                    v-model="form.orderStatus"
                    placeholder="请选择订单状态"
                    class="input"
                    size="small"
                    style="display: inline; margin: 0 0 0 27px"
                  >
                    <el-checkbox
                      v-for="(value, key) in dictData['order_status']"
                      :key="value.value"
                      :label="value.value"
                      >{{ value.label }}
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="平台渠道：" prop="fundType">
                <el-select
                  clearable
                  v-model="form.platNo"
                  placeholder="请选择平台渠道"
                  class="input"
                  style="width: 100%"
                  size="small"
                >
                  <el-option
                    v-for="(value, index) in dictData['plat_no']"
                    :key="index"
                    :label="value.label"
                    :value="value.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="付款时间：" prop="time">
                <el-date-picker
                  size="small"
                  v-model="dateTime"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item style="text-align: right" label="" prop="fundType">
                <el-button type="primary" size="small" @click="loadData"
                  >搜索</el-button
                >
                <el-button size="small" @click="resetForm">重置</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="form-body">
      <div style="overflow: hidden">
        <span style="float: left">
          <el-button
            v-if="false"
            type="primary"
            size="small"
            @click="handleExport"
            >导出</el-button
          >
        </span>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="form.pageNum"
          :limit.sync="form.pageSize"
          @pagination="loadData"
          :layout="'slot, total, sizes, prev, pager, next, jumper'"
        >
        </pagination>
      </div>
      <el-table
        :header-cell-style="{ 'text-align': 'center' }"
        border
        :data="tableData"
      >
        <el-table-column
          align="center"
          label="订单号"
          prop="statDate"
          width="190"
        >
          <template slot-scope="scope">
            <span
              style="color: #409eff; cursor: pointer"
              @click="edit(scope.row)"
              >{{ scope.row.appNo }}</span
            >
          </template>
        </el-table-column>
        <el-table-column align="center" label="店铺名称">
          <template slot-scope="scope">
            <span>{{ scope.row.shopName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="95"
          align="center"
          label="订单状态"
          prop="orderStatus"
        >
          <template slot-scope="scope">
            <span>{{ dictMap["order_status"][scope.row.orderStatus] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          align="center"
          label="付款时间"
          prop="payTime"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.payTime }}</span>
          </template>
        </el-table-column>
        <el-table-column :width="orderWidth" label="产品信息" prop="payFareNum">
          <template slot-scope="scope">
            <div class="table-info-wrap">
              <div
                class="table-info"
                v-for="(item, index) in scope.row.skuList"
                :key="index"
                v-if="(index < 3 && !scope.row.expand) || scope.row.expand"
              >
                <div class="left">
                  <el-popover placement="bottom" trigger="hover">
                    <div
                      v-if="
                        scope.row.productType == '01' &&
                        scope.row.orderStatus == '01'
                      "
                      style="text-align: center; padding: 4px 0"
                    >
                      <a
                        style="float: left; font-weight: bold"
                        target="_blank"
                        :href="`${item.ifNewDesign == '01' ? getDesignUrl : '/design/online/tool'}?designId=${item.designId}`"
                        >重新设计</a
                      >
                      <a
                        style="float: right; font-weight: bold"
                        target="_blank"
                        :href="`${item.ifNewDesign == '01' ? getDesignUrl : '/design/online/tool'}?designId=${item.designId}&appSkuId=${item.appSkuId}&pId=${item.pId}`"
                        >替换产品</a
                      >
                      产品编号：{{ item.pId }}
                    </div>
                    <div>
                      <img
                        style="width: 320px; height: 320px"
                        :src="
                          item.picUrl
                            ? `${item.picUrl}?x-oss-process=image/resize,m_fill,h_500,w_500`
                            : noImage
                        "
                      />
                    </div>
                    <div v-if="item.customizedUrl">
                      <a
                        style="font-weight: bold"
                        target="_blank"
                        :href="item.customizedUrl"
                        >客户图片下载</a
                      >
                    </div>
                     <div v-if="item.amazonPicUrl && item.platNo == '03'">
                      <a
                        style="font-weight: bold"
                        target="_blank"
                        :href="item.amazonPicUrl"
                        >产品图片下载</a
                      >
                    </div>

                    <div slot="reference" style="position: relative">
                      <img
                        class="mini-img"
                        :src="
                          item.picUrl
                            ? `${item.picUrl}?x-oss-process=image/resize,m_fill,h_500,h_500`
                            : noImage
                        "
                      />
                      <div
                        v-if="item.customizedUrl"
                        class="product-tag"
                        style="background: rgb(64, 158, 255)"
                      >
                        定制设计
                      </div>
                    </div>
                  </el-popover>
                  <div
                    v-if="scope.row.productType == '02'"
                    class="product-type"
                  >
                    {{ scope.row.productType == "01" ? "定制" : "优选" }}
                  </div>
                </div>
                <div class="right">
                  <div
                    style="line-height: 15px; margin: 2px 0 0 0"
                    v-if="item.amazonProductName"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="`${item.amazonProductName}`"
                      placement="top-start"
                    >
                      <div
                        class="text-ellipsis"
                        style="display: inline-block; width: 350px"
                        :style="{
                          width: Number(orderWidth) - 139 + 'px',
                        }"
                      >
                        <span> {{ item.amazonProductName }}</span>
                      </div></el-tooltip
                    >
                  </div>
                  <div
                    v-if="item.itemSku"
                    :title="item.itemSku"
                    class="text-ellipsis"
                  >
                    {{ item.itemSku }}
                  </div>
                  <div
                    style="
                      color: #409eff;
                      cursor: pointer;
                      line-height: 15px;
                      margin: 2px 0 0 0;
                    "
                    @click="handleOpenDetail(item)"
                    v-if="item.proName"
                  >
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="`${item.proName}${
                        item.designId ? '（' + item.designId + '）' : ''
                      }`"
                      placement="top-start"
                    >
                      <div
                        class="text-ellipsis"
                        style="display: inline-block; width: 350px"
                        :style="{
                          width: Number(orderWidth) - 139 + 'px',
                        }"
                      >
                        <span> {{ item.proName }}</span>
                        <span v-if="item.designId"> ({{ item.designId }})</span>
                      </div></el-tooltip
                    >
                  </div>
                  <div
                    :title="item.properVal"
                    class="text-ellipsis"
                    v-if="item.properName"
                  >
                    <span v-if="item.properName && item.properVal">
                      <span
                        v-for="(i, ind) in [0, 1]"
                        :key="'i_' + ind"
                        style="margin-right: 10px"
                      >
                        {{ item.properName.split(":")[i] }}：
                        {{ item.properVal.split(":")[i] }}
                      </span>
                    </span>
                  </div>
                  <div>数量：{{ item.num || "-" }}</div>
                  <div>
                    <span v-if="item.salePrice" style="margin: 0 8px 0 0"
                      >{{ dictMap["currency_mark"][scope.row.currency]
                      }}{{ item.salePrice || "-" }}</span
                    >
                    <span v-if="item.proPrice"
                      >货款：￥{{ item.proPrice || "-" }}</span
                    >
                  </div>
                </div>
              </div>
              <div
                style="line-height: 36px; margin: -6px 0 0 0"
                v-if="scope.row.skuList.length > 4"
              >
                <span
                  @click="handleExpand(scope.row)"
                  style="color: #409eff; cursor: pointer; margin: 0 0 0 16px"
                  >{{ scope.row.expand ? "收起" : "展开" }}</span
                >
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="169" label="销售统计" prop="saleTotalNum">
          <template slot-scope="scope">
            <div class="loan-wrap">
              <div>
                <span class="title"> 产品金额 </span>
                ：
                <span v-if="scope.row.saleTotal">
                  {{ dictMap["currency_mark"][scope.row.currency] }}
                  {{ scope.row.saleTotal }}
                </span>
                <span v-else>-</span>
              </div>
              <div>
                <span class="title"> 运费 </span>
                ：
                <span v-if="scope.row.saleFare !== null">
                  {{ dictMap["currency_mark"][scope.row.currency] }}
                  {{ scope.row.saleFare }}
                </span>
                <span v-else>-</span>
              </div>
              <div>
                <span class="title"> 销售促销 </span>
                ：
                <span v-if="scope.row.saleDiscount !== null">
                  {{ dictMap["currency_mark"][scope.row.currency] }}
                  {{ scope.row.saleDiscount }}
                </span>
                <span v-else>-</span>
              </div>
              <div>
                <span class="title"> 总计 </span>
                ：
                <span v-if="scope.row.saleActPay">
                  {{ dictMap["currency_mark"][scope.row.currency] }}
                  {{ scope.row.saleActPay }}
                </span>
                <span v-else>-</span>
              </div>
              <div style="text-align: center">
                （产品数:{{ scope.row.skuList.length }} 件数:{{
                  caculateProduct(scope.row.skuList)
                }}）
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="169" label="货款统计" prop="refundOrderNum">
          <template slot-scope="scope">
            <div class="loan-wrap">
              <div>
                <span class="title"> 产品货款 </span>
                ： ¥ {{ scope.row.proTotal || "-" }}
              </div>
              <div>
                <span class="title"> 运费 </span>
                ： ¥ {{ scope.row.proFare || "-" }}
              </div>
              <div>
                <span class="title"> 优惠金额 </span>
                ： ¥ {{ scope.row.proDiscount || "-" }}
              </div>
              <div>
                <span class="title"> 总计 </span>
                ： ¥ {{ scope.row.proActPay || "-" }}
              </div>
              <div>
                <span class="title"> 利润率 </span>
                ：{{
                  scope.row.saleActPay
                    ? scope.row.ext
                      ? scope.row.ext.profit
                      : "-"
                    : "-"
                }}
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="form.pageNum"
        :limit.sync="form.pageSize"
        @pagination="loadData"
      />
    </div>
    <!-- 编辑订单弹窗 -->
    <EditOrder
      v-if="currentOrder && currentOrder.order"
      :canEdit="orderCanEdit"
      :appId="currentAppId"
      :visible="showEdit"
      :orderDetail="currentOrder"
      @onClose="hideEdit"
      @onUpdate="onUpdateFinish"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumb from "@/components/common/Breadcrumb"
import { selectSOrderTradeList } from "@/api/order/stats"
import { downLoadExcel } from "@/utils/zipdownload"
import qs from "qs"
import { getShopList } from "@/api/system/shopManage"
import { listMainChild } from "@/api/system/user"
import noImage from "@/assets/images/no_image.png"
import { getOrderDetail } from "@/api/order/all"
import EditOrder from "../../customProduct/mine/components/EditOrder"

export default {
  name: "Notice",
  components: {
    Breadcrumb,
    EditOrder,
  },
  data() {
    return {
      // 查询参数
      form: {
        pageNum: 1,
        pageSize: 10,
        operNo: [],
        beginTime: undefined,
        endTime: undefined,
        shopIds: [],
        statType: "1",
        orderStatus: [],
      },
      noImage: noImage,
      dateTime: [],
      payTimeBegin: "",
      payTimeEnd: "",
      monthBegin: "",
      monthEnd: "",
      yearBegin: "",
      yearEnd: "",
      loading: false,
      total: 0,
      tableData: [],
      isExpand: false,
      shopName: "",
      isCheckShop: true,
      shopList: [],
      shopListClone: [],
      userList: [],

      isExpandUser: false,
      nickName: "",
      isCheckUser: true,
      isCheckStatus: true,
      currentOrder: {},
      showEdit: false,
      currentAppId: "",
      orderCanEdit: false,
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap", "user"]),
    orderWidth() {
      let width = document.body.clientWidth
      let orderWidth = "476"
      if (width > 1500) {
        orderWidth = "476"
      } else {
        orderWidth = "339"
      }
      return orderWidth
    },
    getDesignUrl() {
      return localStorage.getItem('isNewDesignFlag') === '2' ? '/design/online/designerOther' : '/design/online/designerNew'
    }
  },
  created() {
    let curDate = new Date()
    let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000 * 7)

    this.dateTime = [
      this.parseTime(preDate, "{y}-{m}-{d}"),
      this.parseTime(curDate, "{y}-{m}-{d}"),
    ]
    this.loadData()
    this.getShops()
    this.getUserList()
  },
  methods: {
    edit(data) {
      getOrderDetail(data.appId).then((res) => {
        if (!res.data.addr) {
          res.data.addr = {}
        }
        this.currentOrder = res.data
        this.currentAppId = data.appId
        this.showEdit = true
        this.orderCanEdit = true
      })
    },
    loadData() {
      this.startLoading()
      if (this.dateTime && this.form.statType == "1") {
        this.form.payTimeBegin = this.dateTime[0]
        this.form.payTimeEnd = this.dateTime[1]
      } else {
        this.form.payTimeBegin = undefined
        this.form.payTimeEnd = undefined
      }

      if (!(this.form.payTimeBegin && this.form.payTimeEnd)) {
        this.form.payTimeBegin = undefined
        this.form.payTimeEnd = undefined
        this.msgError("请输入付款时间")
        this.endLoading()
        return
      }

      let params = Object.assign({}, this.form)
      params.shopIds = params.shopIds.join(",")
      params.operNo = params.operNo.join(",")
      params.orderStatus = params.orderStatus.join(",")

      if (params.shopIds == "" && this.isCheckShop) {
        let shopIds = []
        for (let record of this.shopList) {
          shopIds.push(record.shopId)
        }
        params.shopIds = shopIds.join(",")
      }

      selectSOrderTradeList(params)
        .then((response) => {
          this.tableData = response.rows
          this.total = response.total
          this.endLoading()
        })
        .catch(() => {
          this.endLoading()
        })
    },
    getUserList() {
      listMainChild({}).then((res) => {
        this.userList = res.rows
      })
    },
    onUpdateFinish(appId) {
      if (appId) {
        getOrderDetail(appId).then((res) => {
          this.currentOrder = res.data
        })
      }
    },

    resetForm() {
      this.form = {
        pageNum: 1,
        pageSize: 10,
        operNo: [],
        beginTime: undefined,
        endTime: undefined,
        shopIds: [],
        statType: "1",
        orderStatus: [],
      }
      let curDate = new Date()
      let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000 * 7)

      this.dateTime = [
        this.parseTime(preDate, "{y}-{m}-{d}"),
        this.parseTime(curDate, "{y}-{m}-{d}"),
      ]
    },
    handleChangeStatus() {
      this.form.orderStatus = []
      if (this.isCheckStatus) {
        this.dictData["order_status"].map((record) => {
          this.form.orderStatus.push(record.value)
        })
      }
    },
    hideEdit() {
      this.loadData()
      this.showEdit = false
    },
    handleOpenDetail(row) {
      let routeUrl = this.$router.resolve({
        path: "/select/custom/product",
        query: { pId: row.pId, designId: row.designId },
      })
      window.open(routeUrl.href, "_blank")
    },

    /**导出 */
    handleExport() {
      if (this.form.time) {
        this.form.beginTime = this.form.time[0]
        this.form.endTime = this.form.time[1]
      } else {
        this.form.beginTime = undefined
        this.form.endTime = undefined
      }
      let params = Object.assign({}, this.form)
      delete params["time"]
      delete params["pageSize"]
      delete params["pageNum"]
      downLoadExcel(
        `/money/fund/export?${qs.stringify(this.form)}&fileName=` +
          Math.random(),
        Math.random()
      )
    },
    getShops() {
      getShopList().then((res) => {
        this.shopList = res.rows
        this.shopListClone = this._.clone(res.rows)
        this.$nextTick(() => {
          // this.scrollMenu = document.querySelector(".table-menu")
          // this.objectHeight = this.scrollMenu.offsetTop
          // window.addEventListener("scroll", this.handleScroll)
        })
        // this.handleChangeShop()
        // res.rows.map(()=>{})
      })
    },
    handleChangeShop() {
      this.form.shopIds = []
      if (this.isCheckShop) {
        this.shopList.map((record) => {
          this.form.shopIds.push(record.shopId)
        })
      }
    },
    handleChangeUser() {
      this.form.operNo = []
      let shopList = this._.clone(this.shopListClone)
      if (this.isCheckUser) {
        this.userList.map((record) => {
          this.form.operNo.push(record.userName)
        })
        this.shopList = shopList
      } else {
        this.shopList = []
      }
      this.form.shopIds = []
    },
    handleChangeOper() {
      let shopList = this._.clone(this.shopListClone)
      this.shopList = shopList.filter((shop) => {
        if (this.form.operNo.includes(this.user.name)) {
          return true
        }
        for (let record of this.userList) {
          if (this.form.operNo.includes(record.userName)) {
            if (record.shops) {
              for (let item of record.shops) {
                if (item.shopId == shop.shopId) {
                  return true
                }
              }
            }
          }
        }
        return false
      })
      this.form.shopIds = []
      if (this.form.operNo.length == 0 && this.isCheckUser) {
        this.shopList = this._.clone(this.shopListClone)
      }
    },
    caculateProduct(data) {
      let count = 0
      for (let record of data) {
        count += Number(record.num)
      }
      return count
    },
  },
}
</script>
<style lang="scss" scoped>
.btn-bar-right {
  text-align: right;
}

.table-info-wrap {
  margin-bottom: -10px;
}

.table-info {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 10px;
  padding: 0 10px 0 10px;
}

.table-info:last-child {
  margin-bottom: 0;
  border-bottom: 0;
}

.table-info .left {
  margin-right: 12px;
  width: 111px;
  height: 111px;
  margin-bottom: 10px;
  position: relative;
}

.table-info .left .mini-img {
  width: 109px;
  height: 109px;
  border: 1px solid #dddddd;
}

.table-info .right {
  font-size: 12px;
  width: 200px;
  padding: 0 0 4px 0;
}
.loan-wrap .title {
  width: 60px;
  display: inline-block;
  text-align: justify;
  -moz-text-align-last: justify;
  text-align-last: justify;
}
.product-type {
  position: absolute;
  left: 4px;
  top: 4px;
  border-color: rgb(255, 144, 0);
  background-color: rgb(255, 144, 0);
  height: 20px;
  padding: 0 5px;
  line-height: 19px;
  color: #fff;
  font-size: 12px;
  border-radius: 5px;
}
.product-tag {
  position: absolute;
  left: 4px;
  top: 4px;
  border-color: #ff9000;
  background-color: #ff9000;
  height: 20px;
  padding: 0 5px;
  line-height: 19px;
  color: #fff;
  font-size: 12px;
  border-radius: 5px;
}
</style>
